import { UserState, UserActionTypes } from './types';

const initialState: UserState = {
  errors: {},
  user: null,
  updateNameFlow: {
    firstName: '',
    lastName: '',
    nextScreen: 'Home'
  },
  userOrders: [],
  userOrdersDetails: {
    totalItems: 0,
    totalPages: 0,
    currentPage: null
  },
  userView: 'orders',
  userTransactions: [],
  userTransactionsDetails: {
    totalItems: 0,
    totalPages: 0,
    rewardPointsBalance: 0,
    currentPage: null
  },
  userLocations: []
};

const userReducer = (state = initialState, action: UserActionTypes): UserState => {
  switch (action.type) {
    case 'UPDATE_USER':
      return {
        ...state,
        user: action.payload
      };
    case 'SET_UPDATE_NAME_INPUTS':
      return {
        ...state,
        updateNameFlow: action.payload
      };
    case 'GET_USER_ORDERS_SUCCESS':
      return {
        ...state,
        userOrders: action.payload.orders,
        userOrdersDetails: action.payload.details
      };
    case 'GET_USER_ORDERS_FAILURE':
      return {
        ...state,
        errors: { getUserOrders: action.payload }
      };
    case 'GET_USER_TRANSACTIONS_SUCCESS':
      return {
        ...state,
        userTransactions: action.payload.transactions,
        userTransactionsDetails: action.payload.details
      };
    case 'GET_USER_TRANSACTIONS_FAILURE':
      return {
        ...state,
        errors: { getUserTransactions: action.payload }
      };
    case 'GET_USER_LOCATIONS_SUCCESS':
      return {
        ...state,
        userLocations: action.payload,
      };
    case 'GET_USER_LOCATIONS_FAILURE':
      return {
        ...state,
        errors: { getUserLocations: action.payload }
      };
    case 'SET_USER_VIEW':
      return {
        ...state,
        userView: action.payload
      };
    default:
      return state;
  }
};

export default userReducer;